import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
import './Education.css';
import ReactGA from "react-ga4";
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function Education() {
  const location = useLocation()
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto' // This will make it jump to the top without smooth scrolling
    });
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Education Page' });
  }, []);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Education</title>
      </Helmet>
      <div className="blog-container">
        <h1 className="blog-header">Welcome to our Educational and Institutions Program! </h1>
        <h5>Partner with Blue Planet Ecosystem
        </h5>
        <p className="blog-text">We are committed to promoting sustainability and environmental consciousness within
          organizations and community groups. Our mission is to foster a healthy blue planet by encouraging tree
          planting and nurturing partnerships with like-minded organizations and institutions.
        </p>
        <img src="/img/img/service-3.jpg" alt="" className="blog-img" />
        <h2 className="blog-highlight">How it works:
        </h2>
        <div className="blog-section">
          <h5>Sign up:
          </h5>
          <p className="blog-text">Register your organization or community group on our platform, and we will provide you
            with a unique referral link and logo.
          </p>
        </div>
        <p className="blog-text" style={{color: 'green'}}>
        </p><h5>Free Tree for Everyone:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Every member who signs up through your referral link will receive a
          free tree to plant and help local communities with more mangrove forests that excel at not only producing
          oxygen but removing CO2 and other pollutants their surroundings.
        </p>
        <h5> Help us Plant More Mangroves:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>For every new donation by your members to plant a tree, each dollar
          ($) goes to a new, healthy mangrove. By promoting our shared responsibility, new forests are being created
          around the world.
        </p>
        <h5> Partnership Rewards:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>We believe in fostering collaboration, so we offer 20% of all
          partnership dollars back to our partner organizations. The more trees your members plant, the more funds you
          receive to further your own blue planet initiatives.
        </p>
        <h5>Environmental Impact:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>With every tree planted, you and your members actively participate in
          combatting climate change, preserving biodiversity, and enhancing air quality.
        </p>
        <h5>Strengthen Community Bonds:
        </h5>
        <p className="blog-text" style={{color: 'green'}}> By coming together for a common cause, your organization fosters a
          sense of camaraderie and purpose.
        </p>
        <h5>Fundraising Opportunities:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Our partnership program ensures you receive additional funds to
          support your organization's initiatives.
        </p>
        <h5>Easy-to-Use Platform:
        </h5>
        <p className="blog-text" style={{color: 'green'}}>Our user-friendly interface allows seamless sign-ups and tree tracking
          for your members.
        </p>
        <p className="blog-text" style={{color: 'green'}}>
          Join us in making a difference. Let's grow a forest of change, one tree at a time. Sign up with Blue Planet
          Ecosystem today and let's create a healthy blue planet together!
        </p>
      </div>
      <Link className="btn btn-primary btn-lg" to="/site/signup" id='btn-signup'>Sign Up</Link>
    </div>
  );
}

export default Education;